import React, { Component } from 'react';

class OurVision extends Component {

  render() {
    return (
      <section>
        <div id="top-content-region" className="top-content padding-top-15 padding-bottom-15 block-15 bg-color-grayLight1">
          <div className="container">
            <div className="row">
              <div id="top-content-left-region" className="top-content-left col-xs-12 col-md-6 text-center-sm">
                <div id="page-title-block" className="page-title block">
                  <h1>Our Vision</h1>
                </div>
              </div>

              <div id="top-content-right-region" className="top-content-right col-xs-12 col-md-6 text-right text-center-sm">
                <div id="page-breadcrumbs-block" className="page-breadcrumbs block">
                  <div className="breadcrumbs">
                    <a href="/">Home</a>
                    <span className="delimiter">›</span>
                    <span title="" className="nolink">Visit Us</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="content-region">
          <div className="container">
            <div className="row">
              <div id="main-content-region" className="main-content col-xs-12">
                <div className="region region-content">
                  <div id="block-system-main" className="block block-system">
                    <div className="content">
                      <div className="node node-page clearfix">
                        <div className="content">
                        <h2 className="header-lightBlue"><em>Win. Build. Send.</em></h2>
                        <p className="ministry-text">Cornerstone&apos;s vision is simply to <span className="lightBlue-text-bold">win</span> people to Christ, to <span className="lightBlue-text-bold">build</span> them up with the gospel, and then to <span className="lightBlue-text-bold">send</span> them out to proclaim the good news!
                        <br /><br />
                        Our mission is to make the life-changing wisdom of the Bible understandable and accessible to all.</p>
                        </div>



                </div>
                  </div>
                </div>  </div>



                        </div>




                      </div>
                    </div>
                  </div>
      </section>
    );
  }
}

export default OurVision;
